/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import fetch from '../../apiClient'
import type {
  Client,
  RequestConfig,
  ResponseErrorConfig,
} from '../../apiClient'
import type { GetDocumentQuotaQueryResponse } from '../types/GetDocumentQuota'

function getGetDocumentQuotaUrl() {
  const res = { method: 'GET', url: `/api/v1/documents/quota/` as const }
  return res
}

/**
 * @description Get storage quota information for user's company.
 * Returns:
 * DocumentContainerQuotaSerializer with max_size, current_usage,
 * remaining_space, and usage_percentage
 * @summary Get storage quota for the current company
 * {@link /api/v1/documents/quota/}
 */
export async function getDocumentQuota(
  config: Partial<RequestConfig> & { client?: Client } = {}
) {
  const { client: request = fetch, ...requestConfig } = config

  const res = await request<
    GetDocumentQuotaQueryResponse,
    ResponseErrorConfig<Error>,
    unknown
  >({
    method: 'GET',
    url: getGetDocumentQuotaUrl().url.toString(),
    ...requestConfig,
  })
  return res.data
}
